import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import { selectThemeColors } from '@utils';
import { handleChangeController } from '@redux/actions/form';
import { startAddSelectOptions } from '@redux/actions/selects';
import { removeError } from '@redux/actions/validator';
import { InputValidator } from './InputValidator';
import { useCollection } from '../../../utility/hooks/useCollection';
import { editCollectionRegister } from '../../../redux/actions/form';
import { serverRequest } from '../../../utility/helpers/Axios/serverRequest';
import ReactSelect from 'react-select';
import { useParams } from 'react-router-dom';
import { handleExtraUrl } from '../../../utility/helpers/handleFilter';
import { CopyInClipcoard } from './CopyInClipcoard';

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: '#929292',
  fontSize: '12px',
};
const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D !important',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

export const Select = (properties) => {
  const {
    name,
    label,
    className = '',
    endPoint,
    collection = [],
    placeholder = label,
    labelName = 'name',
    errMsg = 'Campo requerido',
    isClearable = true,
    onSelect,
    containerStyle = {},
    containerClassname = 'mt-1',
    styles = { menuPortal: (base) => ({ ...base, zIndex: 1051 }) },
    defecto = (a) => {},
    master = null,
    isDisabled = false,
    isEnum = false,
    dependsOn = false,
    isCreatable = false,
    menuPlacement = 'bottom',
    customOptions = null,
    customSelectName = endPoint,
    excludeOpt = [],
    copyable = false,
  } = properties;

  const dispatch = useDispatch();
  const params = useParams();
  const { form, select, validator } = useSelector((state) => state);
  const nodeForm = useCollection().getCollectionNode(form, collection);
  const validationError = validator.errors.includes(name);
  let options;
  if (!!customOptions) options = customOptions;
  else if (!!dependsOn) {
    options = select[endPoint]?.filter(
      (f) =>
        nodeForm[dependsOn]?.includes(f.value) ||
        nodeForm[dependsOn]?.some((a) => a?.id === f.value),
    );
  } else {
    options = isEnum ? select[name] : select[customSelectName];
  }

  options = options?.filter((opt) => !excludeOpt.includes(opt.value));

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );

  const ComponentSelector = !!isCreatable ? CreatableSelect : ReactSelect;

  const value = options?.find((o) => o.value === nodeForm?.[name]);

  const handleChange = (target) => {
    const value = target ? target.value : null;

    if (validator.errors && validator.errors[name])
      delete validator.errors[name];
    if (collection.length === 0) dispatch(handleChangeController(name, value));
    else dispatch(editCollectionRegister(collection, { name, value }));
    dispatch(removeError(validator.errors));
    dispatch(handleChangeController('edited', true));
  };

  const getMasterAdditionalLogic = () => {
    if (master?.extraUrl) {
      return {
        ...master,
        extraUrl: handleExtraUrl(master?.extraUrl, params),
        filter: { ...master?.filter },
      };
    } else {
      if (master?.filter || master?.or) {
        return master;
      } else {
        if (master?.name instanceof Array) {
          const values = [];
          for (const name of master?.name) {
            values.push(nodeForm[name] || form[name]);
          }
          if (values.some((s) => !s)) return () => {};
          return master?.onChange(values, dispatch);
        }
        return master?.onChange(
          nodeForm[master?.name] || form[master?.name],
          dispatch,
        );
      }
    }
  };

  const handleCreate = async (newValue) => {
    const intValidation = Number.isInteger(Number(newValue));
    const newOption = intValidation ? parseInt(newValue) : newValue;
    await serverRequest(endPoint, null, { name: newOption }, 'POST').then(
      (res) => {
        dispatch(
          startAddSelectOptions(
            endPoint,
            customSelectName,
            labelName,
            getMasterAdditionalLogic(),
          ),
        );
        if (!collection) dispatch(handleChangeController(name, res.id));
        else
          dispatch(editCollectionRegister(collection, { name, value: res.id }));
      },
    );
  };
  useEffect(() => {
    if (endPoint)
      dispatch(
        startAddSelectOptions(
          endPoint,
          isEnum ? name : customSelectName,
          labelName,
          getMasterAdditionalLogic(),
        ),
      );
    defecto(dispatch);
  }, [nodeForm[master?.name] || form[master?.name]]);

  return (
    <div className={`${containerClassname} `} style={{ ...containerStyle }}>
      {label && (
        <label className="control-label d-flex justify-content-between">
          {label}{' '}
          {copyable && (
            <CopyInClipcoard
              value={value?.label}
              label={label}
              className={'w-5'}
            />
          )}
        </label>
      )}
      <ComponentSelector
        key={`${name}_${collection?.join('_')}`}
        isClearable={isClearable}
        className={`${className} ${
          validationError ? 'border-danger rounded' : ''
        }`}
        name={name}
        isDisabled={
          isDisabled
            ? isDisabled
            : !isCreatable &&
              (options?.length === 0 || !options) &&
              (customOptions?.length === 0 || !customOptions)
        }
        classNamePrefix={'select'}
        theme={selectThemeColors}
        styles={styles}
        options={customOptions !== null ? customOptions : options}
        formatGroupLabel={formatGroupLabel}
        menuPortalTarget={document.body}
        placeholder={placeholder}
        value={value}
        onChange={onSelect ? onSelect : handleChange}
        onCreateOption={handleCreate}
        formatCreateLabel={(n) => `Crear nuevo: ${n}`}
        menuPlacement={menuPlacement}
      />

      <InputValidator errMsg={errMsg} validationError={validationError} />
    </div>
  );
};
